import { DriverSettlementGroupByTable } from "../DriverSettlementGroupByTable";
import { DriverSettlementHold } from "../DriverSettlementHold";
import { DriverSettlementPendingReview } from "../DriverSettlementPendingReview";
import { DriverSettlementProcess } from "../DriverSettlementProcess";
import { PayeeTotals } from "../PayeeTotals";
import { Button, DataSource, Layout, LayoutHeader, Panel, Splitter, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlement extends Layout {
    buttonArchiveVoids: Button;
    buttonTimecardProcessing: Button;
    layoutGroupBy: DriverSettlementGroupByTable;
    layoutHold: DriverSettlementHold;
    layoutPayeeTotals: PayeeTotals;
    layoutPendingReview: DriverSettlementPendingReview;
    layoutProcess: DriverSettlementProcess;
    layoutheaderDriverSettlement: LayoutHeader;
    panelContent: Panel;
    sourceDriverSettlementProfile: DataSource;
    sourceDrsTimecard: DataSource;
    sourceOrderPayablesCache: DataSource;
    sourcePayeeCache: DataSource;
    sourceStateFederalTaxDriverSettlement: DataSource;
    sourceVoidedPayablesDriverSettlement: DataSource;
    splitterDriverSettlement: Splitter;
    tabHold: Tab;
    tabPendingReview: Tab;
    tabProcess: Tab;
    tabsetDriverSettlement: Tabset;
    textboxOverrideCutoffDate: Textbox;
    textboxPayrollCutoffDate: Textbox;
}
